export const config = {
  // dev
  // apiUrl: "https://ooapidev.azurewebsites.net/api"

  // live
  apiUrl: "https://otgciapi.azurewebsites.net/api"

  // localhost
  // apiUrl: "https://localhost:44368/api"
}